"use client";

import ErrorScreen from "@/components/ui/error-screen";
import { oktah } from "@/styles/font";

import "./globals.css";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html
      lang="en"
      data-theme="prime"
      className={`${oktah.variable} font-sans`}
    >
      <body className="flex h-screen flex-col items-center justify-center gap-6">
        <ErrorScreen error={error} />
      </body>
    </html>
  );
}
